/**
 * Shared React Query cache windows for reference data — CRM users, client
 * records and similar lists that are read repeatedly while a user works
 * through a screen but change on a scale of hours, not seconds.
 *
 * Kept short deliberately: a record added elsewhere becomes reachable within
 * a few minutes without a page refresh.
 */
export const REFERENCE_DATA_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * How long an unobserved reference-data query survives eviction. Longer than
 * the stale window so a picker closed and reopened, or a tab switched away
 * from and back to, still resolves from cache.
 */
export const REFERENCE_DATA_GC_TIME_MS = 10 * 60 * 1000;
